import { render } from "./Tuurro.vue?vue&type=template&id=0fb67c74&scoped=true"
import script from "./Tuurro.vue?vue&type=script&lang=js"
export * from "./Tuurro.vue?vue&type=script&lang=js"

import "./Tuurro.vue?vue&type=style&index=0&id=0fb67c74&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-0fb67c74"

export default script